import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import PropTypes from "prop-types";

export default (WrappedComponent) => {
  const hocComponent = ({ ...props }) => (
    <Dialog dir={"rtl"} {...props}>
      <DialogTitle>
        <h1 className="text-2xl" style={{ fontFamily: "Almarai-Regular" }}>
          {props.title}
        </h1>
      </DialogTitle>
      <DialogContent dividers>
        <WrappedComponent {...props} />
      </DialogContent>
    </Dialog>
  );

  hocComponent.propTypes = {};

  return hocComponent;
};
